(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("home", {
        template: "",
        bindings: {},
        controller: [HomeComponentCtrl]
    });
    function HomeComponentCtrl() {
        //$timeout(() => {
        //	homePageService.loadHomePage();
        //});
    }
}());
